import React from 'react';
import { CnStatisticContent } from './cn-statistic-content';
import { CnStatisticSide } from './cn-statistic-side';
import { CnStatisticHeader } from './cn-statistic-header';
import { CnStatisticTitle } from './cn-statistic-title/index-pc';
import { CnStatisticAction } from './cn-statistic-action/index-pc';
import { CnStatisticMainValue } from './cn-statistic-main/index-pc';
import { CnStatisticSecondary } from './cn-statistic-secondary/index-pc';
import { CnStatisticSecondaryDeck } from './cn-statistic-secondary-deck/index-pc';
import { CnStatisticProgress } from './cn-statistic-progress/index-pc';
import { CnStatisticAvatar } from './cn-statistic-avatar/index-pc';
import { CnStatisticMiniChart } from './cn-statistic-minichart';
import { CnStatisticGroup } from './cn-statistic-group/index-pc';
import { CnStatisticCardProBase, CnStatisticCardProProps } from './base';

function CnStatisticCardPro(props: CnStatisticCardProProps) {
  return <CnStatisticCardProBase {...props}>{props.children}</CnStatisticCardProBase>;
}

CnStatisticCardPro.Side = CnStatisticSide;
CnStatisticCardPro.Content = CnStatisticContent;
CnStatisticCardPro.Header = CnStatisticHeader;
CnStatisticCardPro.Group = CnStatisticGroup;

CnStatisticCardPro.Title = CnStatisticTitle;
CnStatisticCardPro.Action = CnStatisticAction;
CnStatisticCardPro.MainValue = CnStatisticMainValue;
CnStatisticCardPro.Secondary = CnStatisticSecondary;
CnStatisticCardPro.SecondaryDeck = CnStatisticSecondaryDeck;
CnStatisticCardPro.Progress = CnStatisticProgress;
CnStatisticCardPro.Avatar = CnStatisticAvatar;
CnStatisticCardPro.MiniChart = CnStatisticMiniChart;

export { CnStatisticCardPro };
